import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import Table from "../../core/common/dataTable/index";
import { all_routes } from "../router/all_routes";
import { DatePicker, Drawer, message } from "antd";
import DeleteModal1 from "../../core/modals/deleteModal1";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import dayjs, { Dayjs } from "dayjs";
import { AppDispatch } from "../../core/data/redux/store";
import {
  fetchAllDepartments,
  fetchDepartmentById,
} from "../../core/data/redux/department/departmentAction";
import {
  fetchAllDesignations,
  fetchDesignationById,
} from "../../core/data/redux/designation/designationAction";
import {
  getEmployees,
  getEmployeeById,
} from "../../core/data/redux/employee/employeeAction";
import {
  createPromotion,
  fetchAllPromotion,
  UpdatePromotion,
  deletepromotion,
} from "../../core/data/redux/promotion/promotionAction";
import moment from "moment";
import { formatDate } from "../../core/utils/configFormatters";
import { filterData } from "../../core/common/GlobalFunctions/tableFilters";
import { filterByStatus } from "../../core/utils/filterActiveData";
import { fetchEmployeeDetailsById } from "../../core/data/redux/resignation/resignationAction";
import { useAppConfig } from "../../customhooks/useAppConfig";
import { decryptData } from "../../core/utils/encryptUtils";
import { fetchPayscales } from "../../core/data/redux/payroll/payrollComponent/payscale/payscaleActions";
import { fetchAllBranch } from "../../core/data/redux/branch/branch.Action";

interface SelectOption {
  value: number;
  label: string;
}

interface FormData {
  Employee: SelectOption | null;
  promotionTo: SelectOption | null;
  promotionDate: any;
  newGrade: string;
  newDepartment: SelectOption | null;
  newManager: SelectOption | null;
  relocate: any;
  existingGrade: any;
  address: string;
  oldManager: any;
  oldDepartment: string;
  promotionfrom: any;
  createdBy: any;
}

const Promotion = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { departments } = useSelector((state: any) => state.department);
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const { designations } = useSelector((state: any) => state.designation);
  const { promotion, loadingStates } = useSelector((state: any) => state.promotion);
  const [isEditing, setIsEditing] = useState(false);
  const isLoading = isEditing ? loadingStates.update : loadingStates.create;
  const { employees } = useSelector((state: any) => state.employee);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
  const [relocate, setRelocate] = useState(false);
  const [tableKey, setTableKey] = useState(0);
  const [address, setAddress] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState<any | null>({});
  const [selectedDesigantion, setSelectedDesignation] = useState<any | null>(
    {}
  );
  const [empselectedDepartment, setempselectedDepartment] = useState<
    any | null
  >({});
  const [promotionDate, setPromotionDate] = useState<Dayjs | null>(null);
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [selectedSort, setSelectedSort] = useState<any>("Recently Added");
  const [selectedRowData, setSelectedRowData] = useState<any>();
  const { payscales } = useSelector((state: any) => state.payroll.payrollScall);
  const { branch } = useSelector((state: any) => state.branch);
  console.log(branch, 'branch')
  const Id = selectedRowData?.Id;
  const { user } = useSelector((state: any) => state.auth);
  const [formData, setFormData] = useState<any>({
    Employee: null,
    promotionTo: null,
    promotionDate: "",
    newGrade: "",
    existingGrade: "",
    newDepartment: null,
    newManager: null,
    relocate: false,
    address: "",
    oldManager: null,
    oldManagerLabel: "",
    oldDepartment: null,
    oldDepartmentLabel: "",
    promotionfrom: null,
    promotionfromLabel: "",
    createdBy: user.UserId,
    experienceLevel: ''
  });
  const formattedPayScales = payscales?.map((item: any) => ({
    label: `${item.ExperienceLabel} (${item.SalaryRangeMin} - ${item.SalaryRangeMax})`,
    value: item.Id,
    ExperienceLevel: item.ExperienceLevel,
    ExperienceLabel: item.ExperienceLabel
  })) || [];

  const [errors, setErrors] = useState<{ [key: string]: string }>({});


  const isValidSelect = (field: any) =>
    field && typeof field === "object" && "value" in field && field.value;

  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};

    if (!isValidSelect(formData.Employee)) newErrors.Employee = "Employee is required.";
    if (!formData.promotionDate) newErrors.promotionDate = "Promotion Date is required.";
    if (!formData.newGrade) newErrors.newGrade = "New Grade is required.";
    if (formData.relocate && !formData.address?.trim()) newErrors.address = "Address is required when relocating.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };




  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];

  const canAdd =
    permissions.includes("Add") || permissions.includes("AllowAll");
  const canView =
    permissions.includes("View") || permissions.includes("AllowAll");
  const canEdit =
    permissions.includes("Edit") || permissions.includes("AllowAll");
  const canDelete =
    permissions.includes("Delete") || permissions.includes("AllowAll");


  const handleChangeEmployee = (field: string, option: any) => {
  if (option) {
    const employeeId = option.value;
    dispatch(getEmployeeById({ employeeId })).then((res) => {
      const employeeData = res.payload.data.employee;

      setSelectedEmployee((prev: any) =>
        prev.EmployeeID !== employeeId ? employeeData : prev
      );

      setFormData((prev: any) => ({
        ...prev,
        Employee: prev.Employee !== option ? option : prev.Employee,
        oldManager:
          prev.oldManager !== employeeData.manager
            ? employeeData.manager
            : prev.oldManager,
        oldDepartment:
          prev.oldDepartment !== employeeData.department
            ? employeeData.department
            : prev.oldDepartment,
        // store branch name (B) as requested
        address:
          prev.address !== employeeData.BranchName
            ? employeeData.BranchName
            : prev.address,
        promotionfrom:
          prev.promotionfrom !== employeeData.designation
            ? employeeData.designation
            : prev.promotionfrom,
      }));
    });
  }
};


  const handleChange = (field: any, value: any) => {
    if (field === "newGrade") {
      const selectedPayScale = formattedPayScales.find(
        (ps: any) => ps.value === value?.value
      );

      setFormData((prev: any) => ({
        ...prev,
        newGrade: value,
        experienceLevel: selectedPayScale?.ExperienceLevel || ""
      }));
    } else {
      setFormData((prev: any) => ({
        ...prev,
        [field]: value,
      }));
    }
  };

  const handleDeletePolicy = (terminationId: any) => {
    const TerminationId = terminationId;
    dispatch(deletepromotion(TerminationId))
      .then((resp: any) => {
        if (resp.meta.requestStatus === "fulfilled") {
          setIsDeleteModalVisible(false);
          message.success(resp.payload.message);
          dispatch(fetchAllPromotion());
        } else {
          setIsDeleteModalVisible(false);
          message.warning(resp.payload.message);
          dispatch(fetchAllPromotion());
        }
      })
      .catch((error: any) => {
        console.error("error is ", error);
      });
  };

  const handleEditPolicy = (record: any): void => {
    setIsEditing(true);
    setSelectedRowData(record);
  };



  useEffect(() => {
    if (formData.Employee && formData.Employee?.value) {
      dispatch(fetchEmployeeDetailsById(formData.Employee.value)).then((res: any) => {
        const data = res?.payload?.data;

        if (data) {
          const department = formattedDepartment.find(
            (opt: any) => opt.label.toLowerCase() === data.DepartmentName?.toLowerCase()
          );

          const designation = formattedDegination.find(
            (opt: any) => opt.label.toLowerCase() === data.DesignationName?.toLowerCase()
          );

          const manager = formattedEmployees.find(
            (opt: any) => opt.label.toLowerCase() === data.SupervisorName?.toLowerCase()
          );

          const matchedPayScale = payscales?.find((item: any) =>
            item.ExperienceLevel === data.experience?.toString() &&
            item.RoleId === data.role_id
          );



          setFormData((prev: any) => ({
            ...prev,
            oldDepartment: department?.value || null,
            oldDepartmentLabel: department?.label || "",
            promotionfrom: designation?.value || null,
            promotionfromLabel: designation?.label || "",
            oldManager: manager?.value || null,
            oldManagerLabel: manager?.label || "",
            existingGrade: matchedPayScale?.ExperienceLabel,
            experienceLevel: matchedPayScale?.ExperienceLevel || "",
            address: data.BranchName
          }));
        }
      });
    }
  }, [formData.Employee]);

  const formattedEmployeess = employees.map((emp: any) => ({
    value: emp.EmployeeID,
    label: emp.Name,
    status: emp.employee_status,
  }));

  const formattedEmployees = filterByStatus(
    formattedEmployeess,
    "active",
    "status"
  );

  // map branches to simple objects if you later want react-select
  const formattedBranches = branch?.data?.map((b: any) => ({
    value: b.Branch_Name,
    label: `${b.Branch_Name}${b.Pincode ? ` - ${b.Pincode}` : ""}`,
  })) || [];




  useEffect(() => {
    if (selectedRowData) {
      const employeeOption = formattedEmployees.find(
        (opt: any) => opt.value === selectedRowData.EmployeeID
      );

      const existingGradeOption = formattedPayScales.find(
        (opt: any) => opt.value?.toString() === selectedRowData.OldSalaryGrade?.toString()
      );

      const newGradeOption = formattedPayScales.find(
        (opt: any) => opt.value?.toString() === selectedRowData.NewSalaryGrade?.toString()
      );

      setFormData({
        Employee: employeeOption || null,
        promotionTo: selectedRowData.PromotionTo || null,
        promotionDate: selectedRowData.Promotion_Date
          ? moment(selectedRowData.Promotion_Date)
          : "",
        newGrade: newGradeOption || "",
        newDepartment: selectedRowData.NewDepartment || null,
        newManager: selectedRowData.NewManager || null,
        existingGrade: existingGradeOption,
        relocate: selectedRowData.Address ? true : false,
        address: selectedRowData.Address || "",
        oldManager: selectedRowData.OldManager || "",
        oldDepartment: selectedRowData.OldDepartment || "",
        promotionfrom: selectedRowData.Promotionfrom || "",
        createdBy: user.UserId,
      });
      if (employeeOption) {
        handleChangeEmployee("employee", employeeOption);
      }
    }
  }, [selectedRowData]);


  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm()) return;

    const transformedData = {
      Employee: formData.Employee?.value || null,
      promotionfrom: formData.promotionfrom?.value || selectedDesigantion?.Id || null,
      promotionTo: formData.promotionTo?.value || null,
      promotionDate: promotionDate ? promotionDate.format("YYYY-MM-DD") : null,
      newGrade: formData.newGrade?.value || null,
      existingGrade: formData?.existingGrade || null,
      newDepartment: formData.newDepartment?.value || null,
      newManager: formData.newManager?.value || null,
      relocate: formData?.relocate,
      address: formData?.relocate ? formData?.address || null : null,
      oldManager: formData?.oldManager?.value || null,
      oldDepartment: empselectedDepartment?.Id || formData.oldDepartment || null,
      createdBy: user?.UserId,
      experienceLevel: formData.experienceLevel
    };

    if (isEditing) {
      dispatch(
        UpdatePromotion({ PromotionId: selectedRowData.Id, data: transformedData })
      ).then((res: any) => {
        if (res.meta.requestStatus === "fulfilled") {
          message.success("Update Successfully");
          dispatch(fetchAllPromotion());
          setIsDrawerVisible(false);
          setErrors({});
        } else {
          message.warning(res.payload.error);
          setErrors({});
        }
      });
    } else {
      dispatch(createPromotion(transformedData)).then((res) => {
        if (res.meta.requestStatus === "fulfilled") {
          message.success("Created Successfully");
          clearformData();
          dispatch(fetchAllPromotion());
          setIsDrawerVisible(false);
          setErrors({});
        } else {
          message.warning(res.payload.error);
          setErrors({});
        }
      });
    }
  };



  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body;
  };



  const formattedDepartment = departments.map((emp: any) => ({
    value: emp.Id,
    label: emp.Name,
  }));

  const activeDesignations = filterByStatus(designations, 'active', 'DesignationStatus');

  const formattedDegination = activeDesignations.map((emp: any) => ({
    value: emp.DesignationId,
    label: emp.DesignationName,
  }));
  const clearformData = () => {
    setFormData({
      Employee: null,
      promotionTo: null,
      promotionDate: "",
      newGrade: "",
      newDepartment: null,
      newManager: null,
      existingGrade: null,
      relocate: false,
      address: "",
      oldManager: "",
      oldDepartment: "",
      promotionfrom: "",
      createdBy: user.UserId,
    });
  };

  useEffect(() => {
    dispatch(fetchAllPromotion());
    dispatch(fetchPayscales());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchAllDepartments());
    dispatch(fetchAllDesignations());
    dispatch(getEmployees());
    dispatch(fetchAllPromotion());
    dispatch(fetchAllBranch());
  }, []);

  useEffect(() => {
    if (selectedEmployee.length > 0) {
      const designationID = selectedEmployee[0].DesignationId;
      dispatch(fetchDesignationById(designationID)).then((res) => {
        setSelectedDesignation(res.payload.data);
      });
    }

    if (selectedEmployee.length > 0) {
      const departmentId = selectedEmployee[0].DepartmentId;
      dispatch(fetchDepartmentById({ departmentId })).then((res) => {
        setempselectedDepartment(res.payload.data);
      });
    }
  }, [selectedEmployee]);

  const data = promotion ? promotion : [];

  const filteredData = useMemo(() => {
    return filterData(data || [], {}, "CreatedAt", "CreatedAt", selectedSort);
  }, [dispatch, promotion, selectedSort, selectedStatus]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [dispatch, promotion, selectedSort, selectedStatus]);

  const config = useAppConfig();
  if (!config) return null;



  const columns = [
    {
      title: "Employee Name",
      dataIndex: "Name",
      render: (text: String, record: any) => (
        <div className="d-flex align-items-center">
          {/* <Link to={all_routes.invoiceDetails} className="avatar avatar-md me-2">
                        <ImageWithBasePath
                            src={`assets/img/users/${record.Image}`}
                            className="rounded-circle"
                            alt="user"
                        />
                    </Link>
                    */}
          <h6 className="fw-medium">
            <div >{record.Name}</div>
            {/* {all_routes.invoiceDetails} */}
          </h6>
        </div>
      ),
      sorter: (a: any, b: any) => a.Name.length - b.Name.length,
    },
    {
      title: "Department",
      dataIndex: "New_Department",
      sorter: (a: any, b: any) =>
        a.New_Department.length - b.New_Department.length,
    },
    {
      title: "Designation From",
      dataIndex: "Promotion_From",
      sorter: (a: any, b: any) =>
        a.Promotion_From.length - b.Promotion_From.length,
    },
    {
      title: "Designation to",
      dataIndex: "Promotion_To",
      sorter: (a: any, b: any) => a.Promotion_To.length - b.Promotion_To.length,
    },
    {
      title: "Promotion Date",
      dataIndex: "Promotion_Date",
      render: (text: string) => {
        if (!text) return "-";
        const date = new Date(text);
        date.setDate(date.getDate() + 1);
        return formatDate(date, config);
      },
      sorter: (a: any, b: any) => {
        const dateA = new Date(a.Promotion_Date).getTime();
        const dateB = new Date(b.Promotion_Date).getTime();
        return dateA - dateB;
      },
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => (
        <div className="action-icon d-inline-flex">
          {/* Edit Icon - permission based */}
          <Link to="#" className="me-2"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Edit">
            <i
              className="ti ti-edit"
              onClick={() => {
                if (!canEdit) return;
                setIsEditing(true);
                handleEditPolicy(record);
                setIsDrawerVisible(true);
              }}
              style={{
                pointerEvents: canEdit ? "auto" : "none",
                cursor: canEdit ? "pointer" : "not-allowed",
                opacity: canEdit ? 1 : 0.5,
              }}
            />
          </Link>

          {/* Delete Icon - permission based */}
          <Link to="#"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Delete">
            <i
              className="ti ti-trash"
              onClick={() => {
                if (!canDelete) return;
                setSelectedRowData(record);
                setIsDeleteModalVisible(true);
              }}
              style={{
                pointerEvents: canDelete ? "auto" : "none",
                cursor: canDelete ? "pointer" : "not-allowed",
                opacity: canDelete ? 1 : 0.5,
              }}
            />
          </Link>
        </div>
      ),
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Promotion</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Promotion
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              {canAdd && (
                <div className="mb-2">
                  <Link
                    to="#"
                    className="btn btn-primary d-flex align-items-center"
                    onClick={(e) => {
                      setIsEditing(false);
                      clearformData();
                      setIsDrawerVisible(true);
                      setErrors({});
                    }}
                  >
                    <i className="ti ti-circle-plus me-2" />
                    Add Promotion
                  </Link>
                </div>
              )}
              <div
                className="head-icons ms-2"
                data-bs-dismiss="modal"
                onClick={() => clearformData}
              >
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Promotion List */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                  <h5 className="d-flex align-items-center">Promotion List</h5>
                  <div className="d-flex align-items-center flex-wrap row-gap-3">
                    <div className="dropdown">
                      <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        {selectedSort
                          ? `Sort By : ${selectedSort}`
                          : "Sort By : Last 7 Days"}
                      </Link>
                      <ul className="dropdown-menu dropdown-menu-end p-3">
                        <li>
                          <Link
                            to="#"
                            onClick={() => setSelectedSort("Recently Added")}
                            className="dropdown-item rounded-1"
                          >
                            Recently Added
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            onClick={() => setSelectedSort("Ascending")}
                            className="dropdown-item rounded-1"
                          >
                            Ascending
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            onClick={() => setSelectedSort("Descending")}
                            className="dropdown-item rounded-1"
                          >
                            Descending
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            onClick={() => setSelectedSort("Last Month")}
                            className="dropdown-item rounded-1"
                          >
                            Last Month
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            onClick={() => setSelectedSort("Last 7 Days")}
                            className="dropdown-item rounded-1"
                          >
                            Last 7 Days
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-body p-0">
                  <Table
                    key={tableKey}
                    dataSource={filteredData}
                    columns={columns}
                    Selection={true}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* /Promotion List  */}
        </div>
        {/* Footer */}
        <div className="footer d-sm-flex align-items-center justify-content-between bg-white border-top p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
        {/* /Footer */}
      </div>
      {/* /Page Wrapper */}
      <>
        {/* Add Promotion */}

        <Drawer
          title={isEditing ? "Update Promotion" : "Add Promotion"}
          placement="right"
          width={500}
          onClose={() => setIsDrawerVisible(false)}
          open={isDrawerVisible}
          style={{ marginTop: 50, paddingBottom: 50 }}
        >
          <form>
            <div className="modal-body pb-0">
              <div className="row">
                <div className="col-md-6">
                  <label className="form-label">Employee <span className="text-danger"> *</span></label>
                  <Select
                    options={formattedEmployees.sort((a: any, b: any) => a.label.localeCompare(b.label))}
                    name="Employee"
                    onChange={(option: any) => {
                      handleChange("Employee", option);
                      handleChangeEmployee("employee", option);
                    }}
                    value={formData.Employee}
                  />
                  {errors.Employee && <small className="text-danger">{errors.Employee}</small>}
                </div>
                <div className="col-md-6">
                  <label className="form-label">Promotion From</label>
                  <input
                    name="promotionfrom"
                    type="text"
                    className="form-control"
                    value={formData.promotionfromLabel || ""}
                    readOnly
                    disabled
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Promotion To <span className="text-danger"> *</span></label>
                  <Select
                    options={formattedDegination.sort((a: any, b: any) => a.label.localeCompare(b.label))}
                    name="promotionTo"
                    onChange={(option: any) =>
                      handleChange("promotionTo", option)
                    }
                    value={formattedDegination.find(
                      (opt: any) => opt.value === formData.promotionTo
                    )}
                  />
                  {errors.promotionTo && <small className="text-danger">{errors.promotionTo}</small>}
                </div>

                <div className="col-md-6">
                  <label className="form-label">Promotion Date <span className="text-danger"> *</span></label>
                  <div className="input-icon-end position-relative">
                    <DatePicker
                      name="promotionDate"
                      className="form-control datetimepicker"
                      value={
                        formData.promotionDate
                          ? dayjs(formData.promotionDate)
                          : null
                      }
                      onChange={(newValue) => {
                        setPromotionDate(newValue);
                        handleChange(
                          "promotionDate",
                          newValue ? newValue.format("YYYY-MM-DD") : ""
                        );
                      }}
                      format="YYYY-MM-DD"
                    />

                    <span className="input-icon-addon">
                      <i className="ti ti-calendar text-gray-7" />
                    </span>
                  </div>
                  {errors.promotionDate && <small className="text-danger">{errors.promotionDate}</small>}
                </div>
                <div className="col-md-6">
                  <label className="form-label">Existing Grade <span className="text-danger"> *</span></label>
                  <input
                    type="text"
                    className="form-control"
                    name="existingGrade"
                    disabled
                    value={formData.existingGrade}
                    readOnly
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">New Grade <span className="text-danger"> *</span></label>
                  <Select
                    options={formattedPayScales}
                    name="newGrade"
                    onChange={(option: any) => handleChange("newGrade", option)}
                    value={formData.newGrade}
                  />
                  {errors.newGrade && <small className="text-danger">{errors.newGrade}</small>}
                </div>
                <div className="col-md-6">
                  <label className="form-label">Existing Department</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.oldDepartmentLabel || ""}
                    readOnly
                    disabled
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">New Department <span className="text-danger"> *</span></label>
                  <Select
                    options={formattedDepartment.sort((a: any, b: any) => a.label.localeCompare(b.label))}
                    name=""
                    onChange={(option: any) =>
                      handleChange("newDepartment", option)
                    }
                    value={formattedDepartment.find(
                      (opt: any) => opt.value === formData.newDepartment
                    )}
                  />
                  {errors.newDepartment && <small className="text-danger">{errors.newDepartment}</small>}
                </div>
                <div className="col-md-6">
                  <label className="form-label">Current Manager</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.oldManagerLabel || ""}
                    readOnly
                    disabled
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">New Manager <span className="text-danger"> *</span></label>
                  <Select
                    options={formattedEmployees.sort((a: any, b: any) => a.label.localeCompare(b.label))}
                    onChange={(option: any) =>
                      handleChange("newManager", option)
                    }
                    value={formattedEmployees.find(
                      (opt: any) => opt.value === formData.newManager
                    )}
                  />
                  {errors.newManager && <small className="text-danger">{errors.newManager}</small>}
                </div>
                <div className="col-md-12">
                  <div className="border rounded p-3 mb-3">
                    <label className="form-label">Relocate</label>
                    <div className="d-flex mb-2">
                      <div className="form-check me-3">
                        <input
                          type="radio"
                          className="form-check-input"
                          name="relocate"
                          onChange={() => handleChange("relocate", true)}
                          value="true"
                          checked={formData.relocate === true}
                        />
                        <label className="form-check-label">Yes</label>
                      </div>
                      <div className="form-check">
                        <input
                          type="radio"
                          className="form-check-input"
                          name="relocate"
                          onChange={() => handleChange("relocate", false)}
                          value="false"
                          checked={formData.relocate === false}
                        />
                        <label className="form-check-label">No</label>
                      </div>
                    </div>

                    {formData.relocate && (
                      <div className="form-group">
                        <label className="form-label">New Job Location</label>

                        <select
                          className="form-control"
                          value={formData.address || ""}
                          onChange={(e) => handleChange("address", e.target.value)}
                          required
                        >
                          <option value="">Select Branch</option>

                          {/* show only active branches (or remove filter to show all) */}
                          {branch
                            ?.filter((b: any) => true) // you can change to (b.Status === 'active') if you want only active
                            .map((b: any) => (
                              <option key={b.Id} value={b.Branch_Name}>
                                {b.Branch_Name}
                              </option>
                            ))}
                        </select>

                        {errors.address && <small className="text-danger">{errors.address}</small>}
                      </div>
                    )}


                  </div>
                </div>

              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-white border me-2"
                onClick={() => setIsDrawerVisible(false)}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                onClick={(e) => handleSubmit(e)}
                disabled={isLoading}
              >
                {isLoading && <span className="spinner-border spinner-border-sm me-2" />}
                {isEditing ? "Update Promotion" : "Add Promotion"}
              </button>
            </div>
          </form>
        </Drawer>
      </>
      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() =>
          selectedRowData?.Id && handleDeletePolicy(selectedRowData?.Id)
        }
      />
    </>
  );
};

export default Promotion;
